import { createContext, useContext } from 'react';

/**
 * Which product feature the automations and segments UI is currently rendering for.
 * Engage and Reputation mount the same components under different bases and list rules.
 */
export type FeatureSurfaceName = 'engage' | 'reputation';

export interface FeatureSurface {
  feature: FeatureSurfaceName;
  basePath: string;
  automationsPath: string;
  segmentsPath: string;
  newSegmentPath: string;
  buildAutomationEditPath: (automationId: string) => string;
  buildSegmentEditPath: (canonicalVersionId: string) => string;
}

export const FeatureSurfaceContext = createContext<FeatureSurface | null>(null);

/**
 * Deliberately throws rather than defaulting to Engage: a surface rendered without a provider
 * would otherwise silently link and filter as Engage from inside Reputation.
 */
export function useFeatureSurface(): FeatureSurface {
  const surface = useContext(FeatureSurfaceContext);
  if (!surface) {
    throw new Error('useFeatureSurface must be used within a FeatureSurfaceProvider');
  }
  return surface;
}
